import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'defaultValue',
    standalone: true
})
export class DefaultValuePipe implements PipeTransform {
    transform(value: any, fallback: string = '-'): string {
        if (
            value === null ||
            value === undefined ||
            value === '' ||
            (Array.isArray(value) && value.length === 0)
        ) {
            return fallback;
        }
        return value;
    }
}
